import { ModelSupportedFileTypes } from "../../types";
import { UPLOAD_FILE_BUTTON_TEXT, UPLOAD_FILE_TOOLTIP_TEXT } from "../../constants";
import { useCallback, useMemo } from "react";
import { formatFileType } from "../../utils/formatFileType";
import { isValidMimeType } from "../../utils";
export const useFileUploadConfig = (modelSupportedFileTypes?: ModelSupportedFileTypes[]) => {
  const fileUploadAcceptedFilesFormatted = useMemo(
    () => modelSupportedFileTypes?.map((fileType) => formatFileType(fileType)) || [],
    [modelSupportedFileTypes],
  );

  const isFileUploadSupported = useCallback(
    (fileType: string) => {
      return isValidMimeType(fileType) && modelSupportedFileTypes?.includes(fileType);
    },
    [modelSupportedFileTypes],
  );

  return {
    isFileUploadSupported,
    fileUploadAcceptedFilesFormatted,
    uploadFileButtonText: UPLOAD_FILE_BUTTON_TEXT,
    uploadFileTooltipText: `${UPLOAD_FILE_TOOLTIP_TEXT} ${fileUploadAcceptedFilesFormatted.join(", ")}`,
  };
};
